import React from 'react';
import { Link } from 'react-router-dom';
import ScensobConnectLogo from '../components/brand/ScensobConnectLogo';

/**
 * Catch-all 404 page. Critical for the UAT logout fix — the tester hit
 * /logout (no route) and saw a blank loading screen forever. Now any
 * missing route lands here with clear recovery actions.
 */
export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-slate-50 flex flex-col items-center justify-center px-4" data-testid="not-found-page">
      <ScensobConnectLogo variant="mark" size={64} className="mb-4" />
      <p className="text-xs uppercase tracking-wider text-violet-600 font-semibold">Error 404</p>
      <h1 className="text-4xl font-bold text-slate-900 mt-2">Page not found</h1>
      <p className="text-slate-600 mt-3 text-center max-w-md">The page you were looking for doesn't exist, or has been moved. Here are some places you can go instead:</p>
      <div className="flex flex-wrap gap-3 mt-6 justify-center">
        <Link to="/" className="px-4 py-2 bg-violet-600 hover:bg-violet-700 text-white rounded-lg font-medium" data-testid="not-found-home">Home</Link>
        <Link to="/login" className="px-4 py-2 bg-white border border-slate-300 hover:bg-slate-100 text-slate-700 rounded-lg font-medium" data-testid="not-found-login">Sign in</Link>
        <Link to="/contact" className="px-4 py-2 bg-white border border-slate-300 hover:bg-slate-100 text-slate-700 rounded-lg font-medium" data-testid="not-found-contact">Contact us</Link>
      </div>
    </div>
  );
}
